export default "__VITE_ASSET__zb3iSVIj__"